import { BffApiClient } from '@/common/services/api/bffClient';
import { LogsActionsServiceName } from '@/common/constants';
import type { RequestLogEntry, RequestLogsQuery } from '../types';

const buildQueryString = (query: RequestLogsQuery): string => {
  const params = new URLSearchParams();
  params.set('serviceName', query.serviceName);

  if (query.username?.trim()) {
    params.set('username', query.username.trim());
  }

  if (query.fullname?.trim()) {
    params.set('fullname', query.fullname.trim());
  }

  if (query.from) {
    params.set('from', query.from);
  }

  if (query.to) {
    params.set('to', query.to);
  }

  if (query.minStatusCode !== undefined && query.minStatusCode !== null) {
    params.set('minStatusCode', String(query.minStatusCode));
  }

  if (query.maxStatusCode !== undefined && query.maxStatusCode !== null) {
    params.set('maxStatusCode', String(query.maxStatusCode));
  }

  if (query.top !== undefined && query.top !== null) {
    params.set('top', String(query.top));
  }

  return params.toString();
};

class LogsActionsService {
  async getRequestLogs(query: RequestLogsQuery): Promise<RequestLogEntry[]> {
    if (!query.serviceName) {
      throw new Error('A serviceName is required to fetch request logs.');
    }

    const queryString = buildQueryString(query);
    const response = await BffApiClient.getInstance().get<RequestLogEntry[]>(
      `/api/logs/requests?${queryString}`
    );

    if (!Array.isArray(response.data)) {
      throw new Error('Unexpected request logs response format.');
    }

    return response.data;
  }
}

export const logsActionsService = new LogsActionsService();
export { LogsActionsServiceName };
